/**
 * Lead source page values emitted by map pin summary cards via `data-from-page`.
 *
 * Map pin cards are built entirely on the client from marker data (see
 * `features/searchResultsMap/services/mapper.js`), so the server's `FromPage`
 * value never reaches them. These values mirror the constants in
 * `Nhs.Library/Constants/LeadPage.cs` and must be kept in sync with it.
 */
const LeadPages = {
  community: {
    default: 'CommunityResults.MapCard.Community',
    comingSoon: 'CommunityResults.ComingSoonMapCard.Community',
    basic: 'CommunityResults.MapCard.BasicCommunity',
  },
  masterPlanCommunity: {
    default: 'CommunityResults.MapCard.MasterPlanCommunity',
    comingSoon: 'CommunityResults.ComingSoonMapCard.MasterPlanCommunity',
  },
  plan: {
    default: 'HomeResults.MapCard.Plan',
    comingSoon: 'HomeResults.ComingSoonMapCard.Plan',
    basic: 'HomeResults.MapCard.BasicPlan',
  },
  spec: {
    default: 'HomeResults.MapCard.Spec',
    comingSoon: 'HomeResults.ComingSoonMapCard.Spec',
    basic: 'HomeResults.MapCard.BasicSpec',
  },
};

const StateLeadPages = {
  community: {
    default: 'StateSearchResults.MapCard.Community',
    comingSoon: 'StateSearchResults.ComingSoonMapCard.Community',
    basic: 'StateSearchResults.MapCard.BasicCommunity',
  },
  masterPlanCommunity: {
    default: 'StateSearchResults.MapCard.MasterPlanCommunity',
    comingSoon: 'StateSearchResults.ComingSoonMapCard.MasterPlanCommunity',
  },
  plan: {
    default: 'StateSearchResults.MapCard.Plan',
    comingSoon: 'StateSearchResults.ComingSoonMapCard.Plan',
    basic: 'StateSearchResults.MapCard.BasicPlan',
  },
  spec: {
    default: 'StateSearchResults.MapCard.Spec',
    comingSoon: 'StateSearchResults.ComingSoonMapCard.Spec',
    basic: 'StateSearchResults.MapCard.BasicSpec',
  },
};

export { LeadPages, StateLeadPages };
